(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './address-picker', './agree-button', './amount', './bill-item', './brand-footer', './brand-loading', './button', './button-group', './checkbox', './checkbox-group', './checkbox-parent', './countdown', './date-picker', './dialog', './dialog-list', './divider-line', './dropdown-menu', './empty', './error', './field', './field-item', './floating-dialog', './fos-button', './fos-checkbox', './fos-checkbox-all', './fos-checkbox-group', './fos-dialog', './fos-dropdown-menu', './fos-field', './fos-field-item', './fos-radio', './fos-radio-group', './fos-switch', './fos-toast', './icon', './image', './inline-loading', './input-item', './landscape', './lazyload', './list', './loading', './nav-bar', './notice-bar', './number-keyboard', './page-layout', './picker', './picker-address', './picker-time', './popover', './popover-s', './popup', './popup-title-bar', './pull-refresh', './radio', './radio-group', './result-page', './scroll-view', './scroll-view-more', './scroll-view-refresh', './scroll-view-three', './scroll-view-two', './search', './sheets-fixed', './snack-bar', './steps', './steps-item', './sticky', './sub-header', './swiper', './swiper-item', './switch', './tab-bar', './tab-pane', './tab-pane-slide', './tabs', './tabs-slide', './tag', './time-picker', './toast', './transition', './transition-group', './vmic-address-picker'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./address-picker'), require('./agree-button'), require('./amount'), require('./bill-item'), require('./brand-footer'), require('./brand-loading'), require('./button'), require('./button-group'), require('./checkbox'), require('./checkbox-group'), require('./checkbox-parent'), require('./countdown'), require('./date-picker'), require('./dialog'), require('./dialog-list'), require('./divider-line'), require('./dropdown-menu'), require('./empty'), require('./error'), require('./field'), require('./field-item'), require('./floating-dialog'), require('./fos-button'), require('./fos-checkbox'), require('./fos-checkbox-all'), require('./fos-checkbox-group'), require('./fos-dialog'), require('./fos-dropdown-menu'), require('./fos-field'), require('./fos-field-item'), require('./fos-radio'), require('./fos-radio-group'), require('./fos-switch'), require('./fos-toast'), require('./icon'), require('./image'), require('./inline-loading'), require('./input-item'), require('./landscape'), require('./lazyload'), require('./list'), require('./loading'), require('./nav-bar'), require('./notice-bar'), require('./number-keyboard'), require('./page-layout'), require('./picker'), require('./picker-address'), require('./picker-time'), require('./popover'), require('./popover-s'), require('./popup'), require('./popup-title-bar'), require('./pull-refresh'), require('./radio'), require('./radio-group'), require('./result-page'), require('./scroll-view'), require('./scroll-view-more'), require('./scroll-view-refresh'), require('./scroll-view-three'), require('./scroll-view-two'), require('./search'), require('./sheets-fixed'), require('./snack-bar'), require('./steps'), require('./steps-item'), require('./sticky'), require('./sub-header'), require('./swiper'), require('./swiper-item'), require('./switch'), require('./tab-bar'), require('./tab-pane'), require('./tab-pane-slide'), require('./tabs'), require('./tabs-slide'), require('./tag'), require('./time-picker'), require('./toast'), require('./transition'), require('./transition-group'), require('./vmic-address-picker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.addressPicker, global.agreeButton, global.amount, global.billItem, global.brandFooter, global.brandLoading, global.button, global.buttonGroup, global.checkbox, global.checkboxGroup, global.checkboxParent, global.countdown, global.datePicker, global.dialog, global.dialogList, global.dividerLine, global.dropdownMenu, global.empty, global.error, global.field, global.fieldItem, global.floatingDialog, global.fosButton, global.fosCheckbox, global.fosCheckboxAll, global.fosCheckboxGroup, global.fosDialog, global.fosDropdownMenu, global.fosField, global.fosFieldItem, global.fosRadio, global.fosRadioGroup, global.fosSwitch, global.fosToast, global.icon, global.image, global.inlineLoading, global.inputItem, global.landscape, global.lazyload, global.list, global.loading, global.navBar, global.noticeBar, global.numberKeyboard, global.pageLayout, global.picker, global.pickerAddress, global.pickerTime, global.popover, global.popoverS, global.popup, global.popupTitleBar, global.pullRefresh, global.radio, global.radioGroup, global.resultPage, global.scrollView, global.scrollViewMore, global.scrollViewRefresh, global.scrollViewThree, global.scrollViewTwo, global.search, global.sheetsFixed, global.snackBar, global.steps, global.stepsItem, global.sticky, global.subHeader, global.swiper, global.swiperItem, global._switch, global.tabBar, global.tabPane, global.tabPaneSlide, global.tabs, global.tabsSlide, global.tag, global.timePicker, global.toast, global.transition, global.transitionGroup, global.vmicAddressPicker);
    global.index = mod.exports;
  }
})(this, function (exports, _addressPicker, _agreeButton, _amount, _billItem, _brandFooter, _brandLoading, _button, _buttonGroup, _checkbox, _checkboxGroup, _checkboxParent, _countdown, _datePicker, _dialog, _dialogList, _dividerLine, _dropdownMenu, _empty, _error, _field, _fieldItem, _floatingDialog, _fosButton, _fosCheckbox, _fosCheckboxAll, _fosCheckboxGroup, _fosDialog, _fosDropdownMenu, _fosField, _fosFieldItem, _fosRadio, _fosRadioGroup, _fosSwitch, _fosToast, _icon, _image, _inlineLoading, _inputItem, _landscape, _lazyload, _list, _loading, _navBar, _noticeBar, _numberKeyboard, _pageLayout, _picker, _pickerAddress, _pickerTime, _popover, _popoverS, _popup, _popupTitleBar, _pullRefresh, _radio, _radioGroup, _resultPage, _scrollView, _scrollViewMore, _scrollViewRefresh, _scrollViewThree, _scrollViewTwo, _search, _sheetsFixed, _snackBar, _steps, _stepsItem, _sticky, _subHeader, _swiper, _swiperItem, _switch, _tabBar, _tabPane, _tabPaneSlide, _tabs, _tabsSlide, _tag, _timePicker, _toast, _transition, _transitionGroup, _vmicAddressPicker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.VmicAddressPicker = exports.TransitionGroup = exports.Transition = exports.Toast = exports.TimePicker = exports.Tag = exports.TabsSlide = exports.Tabs = exports.TabPaneSlide = exports.TabPane = exports.TabBar = exports.Switch = exports.SwiperItem = exports.Swiper = exports.SubHeader = exports.Sticky = exports.StepsItem = exports.Steps = exports.SnackBar = exports.SheetsFixed = exports.Search = exports.ScrollViewTwo = exports.ScrollViewThree = exports.ScrollViewRefresh = exports.ScrollViewMore = exports.ScrollView = exports.ResultPage = exports.RadioGroup = exports.Radio = exports.PullRefresh = exports.PopupTitleBar = exports.Popup = exports.PopoverS = exports.Popover = exports.PickerTime = exports.PickerAddress = exports.Picker = exports.PageLayout = exports.NumberKeyboard = exports.NoticeBar = exports.NavBar = exports.Loading = exports.List = exports.Lazyload = exports.Landscape = exports.InputItem = exports.InlineLoading = exports.Image = exports.Icon = exports.FosToast = exports.FosSwitch = exports.FosRadioGroup = exports.FosRadio = exports.FosFieldItem = exports.FosField = exports.FosDropdownMenu = exports.FosDialog = exports.FosCheckboxGroup = exports.FosCheckboxAll = exports.FosCheckbox = exports.FosButton = exports.FloatingDialog = exports.FieldItem = exports.Field = exports.Error = exports.Empty = exports.DropdownMenu = exports.DividerLine = exports.DialogList = exports.Dialog = exports.DatePicker = exports.Countdown = exports.CheckboxParent = exports.CheckboxGroup = exports.Checkbox = exports.ButtonGroup = exports.Button = exports.BrandLoading = exports.BrandFooter = exports.BillItem = exports.Amount = exports.AgreeButton = exports.AddressPicker = undefined;

  var _addressPicker2 = _interopRequireDefault(_addressPicker);

  var _agreeButton2 = _interopRequireDefault(_agreeButton);

  var _amount2 = _interopRequireDefault(_amount);

  var _billItem2 = _interopRequireDefault(_billItem);

  var _brandFooter2 = _interopRequireDefault(_brandFooter);

  var _brandLoading2 = _interopRequireDefault(_brandLoading);

  var _button2 = _interopRequireDefault(_button);

  var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

  var _checkbox2 = _interopRequireDefault(_checkbox);

  var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

  var _checkboxParent2 = _interopRequireDefault(_checkboxParent);

  var _countdown2 = _interopRequireDefault(_countdown);

  var _datePicker2 = _interopRequireDefault(_datePicker);

  var _dialog2 = _interopRequireDefault(_dialog);

  var _dialogList2 = _interopRequireDefault(_dialogList);

  var _dividerLine2 = _interopRequireDefault(_dividerLine);

  var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

  var _empty2 = _interopRequireDefault(_empty);

  var _error2 = _interopRequireDefault(_error);

  var _field2 = _interopRequireDefault(_field);

  var _fieldItem2 = _interopRequireDefault(_fieldItem);

  var _floatingDialog2 = _interopRequireDefault(_floatingDialog);

  var _fosButton2 = _interopRequireDefault(_fosButton);

  var _fosCheckbox2 = _interopRequireDefault(_fosCheckbox);

  var _fosCheckboxAll2 = _interopRequireDefault(_fosCheckboxAll);

  var _fosCheckboxGroup2 = _interopRequireDefault(_fosCheckboxGroup);

  var _fosDialog2 = _interopRequireDefault(_fosDialog);

  var _fosDropdownMenu2 = _interopRequireDefault(_fosDropdownMenu);

  var _fosField2 = _interopRequireDefault(_fosField);

  var _fosFieldItem2 = _interopRequireDefault(_fosFieldItem);

  var _fosRadio2 = _interopRequireDefault(_fosRadio);

  var _fosRadioGroup2 = _interopRequireDefault(_fosRadioGroup);

  var _fosSwitch2 = _interopRequireDefault(_fosSwitch);

  var _fosToast2 = _interopRequireDefault(_fosToast);

  var _icon2 = _interopRequireDefault(_icon);

  var _image2 = _interopRequireDefault(_image);

  var _inlineLoading2 = _interopRequireDefault(_inlineLoading);

  var _inputItem2 = _interopRequireDefault(_inputItem);

  var _landscape2 = _interopRequireDefault(_landscape);

  var _lazyload2 = _interopRequireDefault(_lazyload);

  var _list2 = _interopRequireDefault(_list);

  var _loading2 = _interopRequireDefault(_loading);

  var _navBar2 = _interopRequireDefault(_navBar);

  var _noticeBar2 = _interopRequireDefault(_noticeBar);

  var _numberKeyboard2 = _interopRequireDefault(_numberKeyboard);

  var _pageLayout2 = _interopRequireDefault(_pageLayout);

  var _picker2 = _interopRequireDefault(_picker);

  var _pickerAddress2 = _interopRequireDefault(_pickerAddress);

  var _pickerTime2 = _interopRequireDefault(_pickerTime);

  var _popover2 = _interopRequireDefault(_popover);

  var _popoverS2 = _interopRequireDefault(_popoverS);

  var _popup2 = _interopRequireDefault(_popup);

  var _popupTitleBar2 = _interopRequireDefault(_popupTitleBar);

  var _pullRefresh2 = _interopRequireDefault(_pullRefresh);

  var _radio2 = _interopRequireDefault(_radio);

  var _radioGroup2 = _interopRequireDefault(_radioGroup);

  var _resultPage2 = _interopRequireDefault(_resultPage);

  var _scrollView2 = _interopRequireDefault(_scrollView);

  var _scrollViewMore2 = _interopRequireDefault(_scrollViewMore);

  var _scrollViewRefresh2 = _interopRequireDefault(_scrollViewRefresh);

  var _scrollViewThree2 = _interopRequireDefault(_scrollViewThree);

  var _scrollViewTwo2 = _interopRequireDefault(_scrollViewTwo);

  var _search2 = _interopRequireDefault(_search);

  var _sheetsFixed2 = _interopRequireDefault(_sheetsFixed);

  var _snackBar2 = _interopRequireDefault(_snackBar);

  var _steps2 = _interopRequireDefault(_steps);

  var _stepsItem2 = _interopRequireDefault(_stepsItem);

  var _sticky2 = _interopRequireDefault(_sticky);

  var _subHeader2 = _interopRequireDefault(_subHeader);

  var _swiper2 = _interopRequireDefault(_swiper);

  var _swiperItem2 = _interopRequireDefault(_swiperItem);

  var _switch2 = _interopRequireDefault(_switch);

  var _tabBar2 = _interopRequireDefault(_tabBar);

  var _tabPane2 = _interopRequireDefault(_tabPane);

  var _tabPaneSlide2 = _interopRequireDefault(_tabPaneSlide);

  var _tabs2 = _interopRequireDefault(_tabs);

  var _tabsSlide2 = _interopRequireDefault(_tabsSlide);

  var _tag2 = _interopRequireDefault(_tag);

  var _timePicker2 = _interopRequireDefault(_timePicker);

  var _toast2 = _interopRequireDefault(_toast);

  var _transition2 = _interopRequireDefault(_transition);

  var _transitionGroup2 = _interopRequireDefault(_transitionGroup);

  var _vmicAddressPicker2 = _interopRequireDefault(_vmicAddressPicker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var version = '5.0.0-beta.16';
  var install = function install(Vue) {
    if (install.installed) return;

    Vue.component(_addressPicker2.default.name, _addressPicker2.default);
    Vue.component(_agreeButton2.default.name, _agreeButton2.default);
    Vue.component(_amount2.default.name, _amount2.default);
    Vue.component(_billItem2.default.name, _billItem2.default);
    Vue.component(_brandFooter2.default.name, _brandFooter2.default);
    Vue.component(_brandLoading2.default.name, _brandLoading2.default);
    Vue.component(_button2.default.name, _button2.default);
    Vue.component(_buttonGroup2.default.name, _buttonGroup2.default);
    Vue.component(_checkbox2.default.name, _checkbox2.default);
    Vue.component(_checkboxGroup2.default.name, _checkboxGroup2.default);
    Vue.component(_checkboxParent2.default.name, _checkboxParent2.default);
    Vue.component(_countdown2.default.name, _countdown2.default);
    Vue.component(_datePicker2.default.name, _datePicker2.default);
    Vue.component(_dialog2.default.name, _dialog2.default);
    Vue.component(_dialogList2.default.name, _dialogList2.default);
    Vue.component(_dividerLine2.default.name, _dividerLine2.default);
    Vue.component(_dropdownMenu2.default.name, _dropdownMenu2.default);
    Vue.component(_empty2.default.name, _empty2.default);
    Vue.component(_error2.default.name, _error2.default);
    Vue.component(_field2.default.name, _field2.default);
    Vue.component(_fieldItem2.default.name, _fieldItem2.default);
    Vue.component(_floatingDialog2.default.name, _floatingDialog2.default);
    Vue.component(_fosButton2.default.name, _fosButton2.default);
    Vue.component(_fosCheckbox2.default.name, _fosCheckbox2.default);
    Vue.component(_fosCheckboxAll2.default.name, _fosCheckboxAll2.default);
    Vue.component(_fosCheckboxGroup2.default.name, _fosCheckboxGroup2.default);
    Vue.component(_fosDialog2.default.name, _fosDialog2.default);
    Vue.component(_fosDropdownMenu2.default.name, _fosDropdownMenu2.default);
    Vue.component(_fosField2.default.name, _fosField2.default);
    Vue.component(_fosFieldItem2.default.name, _fosFieldItem2.default);
    Vue.component(_fosRadio2.default.name, _fosRadio2.default);
    Vue.component(_fosRadioGroup2.default.name, _fosRadioGroup2.default);
    Vue.component(_fosSwitch2.default.name, _fosSwitch2.default);
    Vue.component(_fosToast2.default.name, _fosToast2.default);
    Vue.component(_icon2.default.name, _icon2.default);
    Vue.component(_image2.default.name, _image2.default);
    Vue.component(_inlineLoading2.default.name, _inlineLoading2.default);
    Vue.component(_inputItem2.default.name, _inputItem2.default);
    Vue.component(_landscape2.default.name, _landscape2.default);
    Vue.component(_list2.default.name, _list2.default);
    Vue.component(_loading2.default.name, _loading2.default);
    Vue.component(_navBar2.default.name, _navBar2.default);
    Vue.component(_noticeBar2.default.name, _noticeBar2.default);
    Vue.component(_numberKeyboard2.default.name, _numberKeyboard2.default);
    Vue.component(_pageLayout2.default.name, _pageLayout2.default);
    Vue.component(_picker2.default.name, _picker2.default);
    Vue.component(_pickerAddress2.default.name, _pickerAddress2.default);
    Vue.component(_pickerTime2.default.name, _pickerTime2.default);
    Vue.component(_popover2.default.name, _popover2.default);
    Vue.component(_popoverS2.default.name, _popoverS2.default);
    Vue.component(_popup2.default.name, _popup2.default);
    Vue.component(_popupTitleBar2.default.name, _popupTitleBar2.default);
    Vue.component(_pullRefresh2.default.name, _pullRefresh2.default);
    Vue.component(_radio2.default.name, _radio2.default);
    Vue.component(_radioGroup2.default.name, _radioGroup2.default);
    Vue.component(_resultPage2.default.name, _resultPage2.default);
    Vue.component(_scrollView2.default.name, _scrollView2.default);
    Vue.component(_scrollViewMore2.default.name, _scrollViewMore2.default);
    Vue.component(_scrollViewRefresh2.default.name, _scrollViewRefresh2.default);
    Vue.component(_scrollViewThree2.default.name, _scrollViewThree2.default);
    Vue.component(_scrollViewTwo2.default.name, _scrollViewTwo2.default);
    Vue.component(_search2.default.name, _search2.default);
    Vue.component(_sheetsFixed2.default.name, _sheetsFixed2.default);
    Vue.component(_snackBar2.default.name, _snackBar2.default);
    Vue.component(_steps2.default.name, _steps2.default);
    Vue.component(_stepsItem2.default.name, _stepsItem2.default);
    Vue.component(_sticky2.default.name, _sticky2.default);
    Vue.component(_subHeader2.default.name, _subHeader2.default);
    Vue.component(_swiper2.default.name, _swiper2.default);
    Vue.component(_swiperItem2.default.name, _swiperItem2.default);
    Vue.component(_switch2.default.name, _switch2.default);
    Vue.component(_tabBar2.default.name, _tabBar2.default);
    Vue.component(_tabPane2.default.name, _tabPane2.default);
    Vue.component(_tabPaneSlide2.default.name, _tabPaneSlide2.default);
    Vue.component(_tabs2.default.name, _tabs2.default);
    Vue.component(_tabsSlide2.default.name, _tabsSlide2.default);
    Vue.component(_tag2.default.name, _tag2.default);
    Vue.component(_timePicker2.default.name, _timePicker2.default);
    Vue.component(_transition2.default.name, _transition2.default);
    Vue.component(_transitionGroup2.default.name, _transitionGroup2.default);
    Vue.component(_vmicAddressPicker2.default.name, _vmicAddressPicker2.default);
    Vue.$toast = Vue.prototype.$toast = _toast2.default;
    Vue.$dialog = Vue.prototype.$dialog = _dialog2.default;
    Vue.$loading = Vue.prototype.$loading = _loading2.default;
  };

  // auto install
  if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  exports.AddressPicker = _addressPicker2.default;
  exports.AgreeButton = _agreeButton2.default;
  exports.Amount = _amount2.default;
  exports.BillItem = _billItem2.default;
  exports.BrandFooter = _brandFooter2.default;
  exports.BrandLoading = _brandLoading2.default;
  exports.Button = _button2.default;
  exports.ButtonGroup = _buttonGroup2.default;
  exports.Checkbox = _checkbox2.default;
  exports.CheckboxGroup = _checkboxGroup2.default;
  exports.CheckboxParent = _checkboxParent2.default;
  exports.Countdown = _countdown2.default;
  exports.DatePicker = _datePicker2.default;
  exports.Dialog = _dialog2.default;
  exports.DialogList = _dialogList2.default;
  exports.DividerLine = _dividerLine2.default;
  exports.DropdownMenu = _dropdownMenu2.default;
  exports.Empty = _empty2.default;
  exports.Error = _error2.default;
  exports.Field = _field2.default;
  exports.FieldItem = _fieldItem2.default;
  exports.FloatingDialog = _floatingDialog2.default;
  exports.FosButton = _fosButton2.default;
  exports.FosCheckbox = _fosCheckbox2.default;
  exports.FosCheckboxAll = _fosCheckboxAll2.default;
  exports.FosCheckboxGroup = _fosCheckboxGroup2.default;
  exports.FosDialog = _fosDialog2.default;
  exports.FosDropdownMenu = _fosDropdownMenu2.default;
  exports.FosField = _fosField2.default;
  exports.FosFieldItem = _fosFieldItem2.default;
  exports.FosRadio = _fosRadio2.default;
  exports.FosRadioGroup = _fosRadioGroup2.default;
  exports.FosSwitch = _fosSwitch2.default;
  exports.FosToast = _fosToast2.default;
  exports.Icon = _icon2.default;
  exports.Image = _image2.default;
  exports.InlineLoading = _inlineLoading2.default;
  exports.InputItem = _inputItem2.default;
  exports.Landscape = _landscape2.default;
  exports.Lazyload = _lazyload2.default;
  exports.List = _list2.default;
  exports.Loading = _loading2.default;
  exports.NavBar = _navBar2.default;
  exports.NoticeBar = _noticeBar2.default;
  exports.NumberKeyboard = _numberKeyboard2.default;
  exports.PageLayout = _pageLayout2.default;
  exports.Picker = _picker2.default;
  exports.PickerAddress = _pickerAddress2.default;
  exports.PickerTime = _pickerTime2.default;
  exports.Popover = _popover2.default;
  exports.PopoverS = _popoverS2.default;
  exports.Popup = _popup2.default;
  exports.PopupTitleBar = _popupTitleBar2.default;
  exports.PullRefresh = _pullRefresh2.default;
  exports.Radio = _radio2.default;
  exports.RadioGroup = _radioGroup2.default;
  exports.ResultPage = _resultPage2.default;
  exports.ScrollView = _scrollView2.default;
  exports.ScrollViewMore = _scrollViewMore2.default;
  exports.ScrollViewRefresh = _scrollViewRefresh2.default;
  exports.ScrollViewThree = _scrollViewThree2.default;
  exports.ScrollViewTwo = _scrollViewTwo2.default;
  exports.Search = _search2.default;
  exports.SheetsFixed = _sheetsFixed2.default;
  exports.SnackBar = _snackBar2.default;
  exports.Steps = _steps2.default;
  exports.StepsItem = _stepsItem2.default;
  exports.Sticky = _sticky2.default;
  exports.SubHeader = _subHeader2.default;
  exports.Swiper = _swiper2.default;
  exports.SwiperItem = _swiperItem2.default;
  exports.Switch = _switch2.default;
  exports.TabBar = _tabBar2.default;
  exports.TabPane = _tabPane2.default;
  exports.TabPaneSlide = _tabPaneSlide2.default;
  exports.Tabs = _tabs2.default;
  exports.TabsSlide = _tabsSlide2.default;
  exports.Tag = _tag2.default;
  exports.TimePicker = _timePicker2.default;
  exports.Toast = _toast2.default;
  exports.Transition = _transition2.default;
  exports.TransitionGroup = _transitionGroup2.default;
  exports.VmicAddressPicker = _vmicAddressPicker2.default;
  exports.default = {
    install: install,
    version: version
  };
});